export const SERVICE_CONSTANTS = {
  baseURL: 'https://apis.apps.weir/iamservice/',
  getUserActivity:
    'useractivities/sign-ins?applicationObjectId=<applicationObjectId>',
};
